    <mat-table *ngIf="myAffirmations.length > 0" style="width:100%;" [dataSource]="myAffirmations">
        <ng-container matColumnDef="position">
            <mat-header-cell  *matHeaderCellDef fxFlex="5" fxLayoutAlign="start center center">AA</mat-header-cell>
            <mat-cell  *matCellDef="let affirmation" class="affirmationTitle" fxFlex="5"
                fxLayoutAlign="start center center"> {{affirmation.position}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="activity_description">
            <mat-header-cell  *matHeaderCellDef fxLayoutAlign="start center center">Δήλωση</mat-header-cell>
            <mat-cell  *matCellDef="let affirmation" class="affirmationTitle"
                fxLayoutAlign="start center center"> {{affirmation.activity_description}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="childDisplayName">
            <mat-header-cell  *matHeaderCellDef  fxLayoutAlign="start center center"> Ονοματεπώνυμο χρήστη</mat-header-cell>
            <mat-cell  *matCellDef="let affirmation" class="consentTitle"
                fxLayoutAlign="start center center"> {{affirmation.childDisplayName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="alt_description">
            <mat-header-cell  *matHeaderCellDef  fxLayoutAlign="center center center">Κατάσταση</mat-header-cell>
            <mat-cell  *matCellDef="let affirmation"  fxLayoutAlign="center center center">
                <div class="statusButton"
                     [ngStyle]="{'background-color': commonService.getAffirmationButtonColor(+affirmation.status)}"
                     fxLayoutAlign="center center center">{{+affirmation.status === 1 ? 'Ενεργή' : +affirmation.status === 2 ? 'Ακυρωμένη' : 'Σε αναμονή'}}</div>
            </mat-cell>
        </ng-container>


        <ng-container matColumnDef="enroll_date">
            <mat-header-cell  *matHeaderCellDef  fxLayoutAlign="center center center">Ημερομηνία
                εγγραφής
            </mat-header-cell>
            <mat-cell  *matCellDef="let affirmation"
                fxLayoutAlign="center center center" [ngStyle]="{'text-decoration' : (affirmation.status_id === 2 ? 'line-through' : 'none')}"> {{affirmation.enroll_date}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cancel_date">
            <mat-header-cell  *matHeaderCellDef  fxLayoutAlign="center center center">Ημερομηνία
                ακύρωσης
            </mat-header-cell>
            <mat-cell  *matCellDef="let affirmation"
                fxLayoutAlign="center center center"> {{affirmation.cancel_date ? affirmation.cancel_date : '-'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
            <mat-header-cell  *matHeaderCellDef  fxLayoutAlign="center center center">Ενέργεια</mat-header-cell>
            <mat-cell  *matCellDef="let affirmation"  fxLayoutAlign="center center center">
                <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" style="cursor: pointer;">
                    <div fxLayout="row" fxLayoutAlign="center center center" fxShow.gt-sm fxHide.lt-md>
                        <!--                  <label style="cursor: pointer;">Ενέργεια</label>-->
                        <button mat-flat-button [ngStyle]="{'background': 'transparent', 'color':'black'}"
                                style="font-family: 'Century Gothic', sans-serif !important;">
                            <mat-icon style="vertical-align: middle; color:var(--haeforangePrimary);">
                                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
                            </mat-icon>
                        </button>

                    </div>
                </div>


                    <mat-menu #menu="matMenu">
                    <mat-list>
                        <mat-list-item class="menuList" >
                            <button mat-menu-item (click)="showCustomForm(affirmation)">
                                <mat-icon class="icon">visibility</mat-icon>&nbsp;Προβολή
                            </button>
                        </mat-list-item>
<!--                        <mat-list-item class="menuList" >-->
<!--                            <button mat-menu-item (click)="cancel(affirmation)">-->
<!--                                <mat-icon class="icon">clear</mat-icon>&nbsp;Ακύρωση-->
<!--                            </button>-->
<!--                        </mat-list-item>-->
                    </mat-list>
                </mat-menu>
            </mat-cell>
        </ng-container>

        <mat-header-row  *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
        <mat-row  *matRowDef="let record; columns: columnsToDisplay"></mat-row>
    </mat-table>
    <div *ngIf="myAffirmations.length === 0" fxLayout="column" fxFlex style="height:300px" fxLayoutAlign="center center center">
      <img src="assets/images/noInfo2.png" style="width:150px; height:150px;" alt="noInfo"/>
      <div
        style="font-family: 'Century Gothic', sans-serif; font-weight: normal; font-size: 18px; margin-top:1em;">
        Δεν έχετε δηλώσεις
      </div>
    </div><!--<div fxLayout="column" style="padding:15px;">-->
<!--    <app-page-header title="Οι δηλώσεις μου" action=''></app-page-header>-->
<!--</div>-->
<!--<div fxLayout="column" style="margin-top:50px; padding:15px;" fxLayoutAlign="center center">-->
<!--    <div fxLayout="column" fxLayoutAlign="center center center" ngStyle.lt-md="width:100%;" ngStyle.md="width:100%;"-->
<!--         ngStyle.lt-lg="width:100%;" ngStyle.gt-lg="width:55%;">-->
<!--        <ng-container *ngIf="isLoading then showLoading else showMyAffirmations"></ng-container>-->
<!--        <ng-template #showLoading>-->
<!--            <app-loading></app-loading>-->
<!--        </ng-template>-->
<!--        <ng-template #showMyAffirmations>-->
<!--            <div fxShow.lt-md fxHide.gt-sm fxLayout="column" style="margin-bottom: 80px;" fxLayoutAlign="center center center" class="cardsContainer">-->

<!--                <mat-card *ngFor="let affirmation of myAffirmations" class="smallCard mat-elevation-z5">-->
<!--                    <mat-card-content>-->

<!--                        <div fxLayout="row" class="headerSection">Δραστηριότητα</div>-->
<!--                        <div fxLayout="row">{{affirmation.activity_description}}</div>-->

<!--                        <div fxLayout="row" class="headerSection">Ον/Επώνυμο παιδιού</div>-->
<!--                        <div fxLayout="row" class="header">{{affirmation.child_first_name}} {{affirmation.child_last_name}}</div>-->

<!--                        <div fxLayout="row" class="headerSection" fxLayoutAlign="start center center">-->
<!--                            <span fxFlex="50" fxLayoutAlign="start center center">Κατάσταση</span>-->
<!--                            <div fxFlex="50" class="statusButton" [ngStyle]="{'background-color': affirmation.status_id !== 2 ? 'green' : 'red'}"-->
<!--                                 fxLayoutAlign="center center center">{{affirmation.alt_description}}</div>-->
<!--                        </div>-->

<!--                        <div fxLayout="row" class="headerSection" fxLayoutAlign="start center center">-->
<!--                            <span fxFlex="50" fxLayoutAlign="start center center">Ημ. Εγγραφής</span>-->
<!--                            <div fxFlex="50"-->
<!--                                 fxLayoutAlign="center center center">{{affirmation.enroll_date}}</div>-->
<!--                        </div>-->

<!--                        <div fxLayout="row" class="headerSection" fxLayoutAlign="start center center">-->
<!--                            <span fxFlex="50" fxLayoutAlign="start center center">Ημ. Ανανέωσης</span>-->
<!--                            <div fxFlex="50"-->
<!--                                 fxLayoutAlign="center center center">{{affirmation.renew_date}}</div>-->
<!--                        </div>-->

<!--                        <div fxLayout="row" class="headerSection">-->
<!--                            <span fxFlex="50" fxLayoutAlign="start center center">Ημ. ακύρωσης</span>-->
<!--                            <div fxFlex="50"-->
<!--                                 fxLayoutAlign="center center center">{{affirmation.cancel_date}}</div>-->
<!--                        </div>-->

<!--                        <mat-divider></mat-divider>-->
<!--                        <div fxLayout="row" fxLayoutAlign="center center center" style="margin-top:20px; margin-bottom:-10px;">-->
<!--                            <button fxFlexAlign="center" (click)="renew(affirmation)" mat-icon-button matTooltip="Ανανέωση">-->
<!--                                <mat-icon>autorenew</mat-icon>-->
<!--                            </button>-->
<!--                            <button (click)="cancel(affirmation)" mat-icon-button [disabled]="affirmation.status_id === 2"-->
<!--                                    matTooltip="Ακύρωση">-->
<!--                                <mat-icon>clear</mat-icon>-->
<!--                            </button>-->

<!--                        </div>-->

<!--                    </mat-card-content>-->
<!--                </mat-card>-->


<!--            </div>-->


<!--            <div fxHide.lt-md fxShow.gt-sm fxLayout="row" fxFlex style="width:100%; margin-bottom: 20px;" fxLayoutAlign="center center center">-->
<!--                <div fxFlex="10" class="descHeader" fxLayoutAlign="start center center">Δραστηριότητα</div>-->
<!--                <div fxFlex="10" class="descHeader" fxLayoutAlign="start center center">Παιδί</div>-->
<!--                <div fxFlex="10" class="descHeader" fxLayoutAlign="start center center">Κατάσταση</div>-->
<!--                <div fxFlex="20" class="descHeader" fxLayoutAlign="center center center">Ημ. Εγγραφής</div>-->
<!--                <div fxFlex="20" class="descHeader" fxLayoutAlign="center center center">Ημ. Ανανέωσης</div>-->
<!--                <div fxFlex="20" class="descHeader" fxLayoutAlign="center center center">Ημ. Ακύρωσης</div>-->
<!--                <div fxFlex="10" class="descHeader" fxLayoutAlign="center center center">Ενέργειες</div>-->
<!--            </div>-->
<!--            <div fxHide.lt-md fxShow.gt-sm fxLayout="row" class="affirmationRow" *ngFor="let affirmation of myAffirmations"-->
<!--                 fxLayoutAlign="center center center">-->
<!--                <div class="info" fxFlex="10"-->
<!--                     fxLayoutAlign="start center center">{{affirmation.activity_description}}</div>-->
<!--                <div class="info" fxFlex="10"-->
<!--                     fxLayoutAlign="start center center">{{affirmation.child_first_name}} {{affirmation.child_last_name}}</div>-->
<!--                <div class="info" fxFlex="10"-->
<!--                     fxLayoutAlign="start center center">{{affirmation.alt_description}}</div>-->
<!--                <div class="info" fxFlex="20" fxLayoutAlign="center center center">{{affirmation.enroll_date}}</div>-->
<!--                <div class="info" fxFlex="20" fxLayoutAlign="center center center">{{affirmation.renew_date}}</div>-->
<!--                <div class="info" fxFlex="20" fxLayoutAlign="center center center">{{affirmation.cancel_date}}</div>-->
<!--                <div class="info" fxFlex="10" fxLayoutAlign="center center center">-->
<!--                    <button (click)="renew(affirmation)" mat-icon-button matTooltip="Ανανέωση">-->
<!--                        <mat-icon>autorenew</mat-icon>-->
<!--                    </button>-->
<!--                    <button (click)="cancel(affirmation)" mat-icon-button [disabled]="affirmation.status_id === 2"-->
<!--                            matTooltip="Ακύρωση">-->
<!--                        <mat-icon>clear</mat-icon>-->
<!--                    </button>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div *ngIf="myAffirmations.length === 0" fxLayout="column" fxLayoutAlign="center center center">-->
<!--                <img src="assets/images/noInfo2.png" alt="no affirmation"/>-->
<!--                <div-->
<!--                        style="font-family: 'Century Gothic', 'Helvetica Neue', sans-serif; margin-top:20px; font-weight: normal; font-size: 18px;">-->
<!--                    Δεν υπάρχουν ενεργές δηλώσεις-->
<!--                </div>-->
<!--            </div>-->
<!--        </ng-template>-->



<!--    </div>-->
<!--</div>-->
